module.exports = __webpack_public_path__ + "static/media/lukso-logo.c9532e8a.svg";